import React from "react";
import { MessageCircle } from "lucide-react";
import { useData } from "../../context/DataContext";

const PreviewWhatsAppButton = () => {
    const { settings } = useData();
    const number = (settings.whatsapp || "").replace(/[^\d]/g, "");
    const link = `https://wa.me/${number}?text=${encodeURIComponent(
        "Hi SouthTrip! I'd like to know more about your Kerala packages.",
    )}`;
    return (
        <a
            href={link}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="preview-whatsapp-floating"
            className="fixed right-4 lg:right-6 z-[75] group"
            style={{
                bottom: "calc(env(safe-area-inset-bottom, 0) + 96px)",
            }}
        >
            <style>{`
                @media (min-width: 1024px) {
                    [data-testid="preview-whatsapp-floating"] {
                        bottom: 24px !important;
                    }
                }
            `}</style>
            <span className="relative flex w-14 h-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl hover:scale-105 transition">
                <span
                    className="absolute inset-0 rounded-full bg-[#25D366] opacity-70"
                    style={{ animation: "hz-pulse-ring 1.8s ease-out infinite" }}
                />
                <MessageCircle className="w-6 h-6 relative z-10" />
            </span>
            <style>{`
                @keyframes hz-pulse-ring {
                    0% { transform: scale(0.95); opacity: 0.6; }
                    70% { transform: scale(1.4); opacity: 0; }
                    100% { transform: scale(1.4); opacity: 0; }
                }
            `}</style>
            <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[var(--ink)] text-white text-xs px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition pointer-events-none hidden lg:block">
                Chat with us · +91 80-75814740
            </span>
        </a>
    );
};

export default PreviewWhatsAppButton;
